export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	aguavberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	apicotberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	brightpowder: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	choiceband: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	clawfossil: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	cornnberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	deepseascale: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	deepseatooth: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	diveball: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	enigmaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	figyberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	ganlonberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	grepaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	hondewberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	kelpsyberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lansatberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	liechiberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lightball: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	magoberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	magostberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	mentalherb: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	nomelberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	petayaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	pomegberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	premierball: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	qualotberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	rabutaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	rootfossil: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	salacberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	scopelens: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	shellbell: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	souldew: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	starfberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	tamatoberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	whiteherb: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	wikiberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
};
